import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/format";

const ACTION_COLOR = {
  create: "bg-[color:var(--bd-green)]/20 text-[color:var(--bd-green-bright)]",
  update: "bg-blue-500/15 text-blue-300",
  delete: "bg-[color:var(--bd-red)]/20 text-[color:var(--bd-red-bright)]",
  login: "bg-white/[0.08] text-white",
  login_failed: "bg-[color:var(--bd-red)]/20 text-[color:var(--bd-red-bright)]",
  payment: "bg-[color:var(--bd-green)]/30 text-[color:var(--bd-green-bright)]",
  email_sent: "bg-purple-500/15 text-purple-300",
};

export default function AuditLog() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/audit").then((r) => setList(r.data)).catch(() => {});
  }, []);

  return (
    <AdminLayout title="Audit Log">
      <div className="text-sm text-[color:var(--ivory-muted)] mb-6">Last {list.length} entries · most recent first</div>
      <div className="rounded-2xl border border-white/10 bg-white/[0.02] overflow-hidden">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-white/[0.03] text-xs uppercase tracking-[0.15em] text-[color:var(--ivory-muted)]">
            <tr>
              <th className="px-4 py-3 text-left">When</th>
              <th className="px-4 py-3 text-left">Actor</th>
              <th className="px-4 py-3 text-left">Action</th>
              <th className="px-4 py-3 text-left">Entity</th>
              <th className="px-4 py-3 text-left">Summary</th>
              <th className="px-4 py-3 text-left">IP</th>
            </tr>
          </thead>
          <tbody>
            {list.map((a) => (
              <tr key={a.id} className="border-t border-white/5 hover:bg-white/[0.02]" data-testid={`audit-row-${a.id}`}>
                <td className="px-4 py-3 text-[color:var(--ivory-muted)] whitespace-nowrap">{formatDateTime(a.created_at)}</td>
                <td className="px-4 py-3">{a.actor_email}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs ${ACTION_COLOR[a.action] || "bg-white/[0.08]"}`}>{a.action}</span>
                </td>
                <td className="px-4 py-3 capitalize">{a.entity_type}</td>
                <td className="px-4 py-3">{a.summary}</td>
                <td className="px-4 py-3 text-[color:var(--ivory-muted)] text-xs">{a.ip || "—"}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="6" className="p-12 text-center text-[color:var(--ivory-muted)]">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
